import {
  IdealistDayEvent as ApiIdealistDayEvent,
  deleteEvent as apiDeleteEvent,
  fetchEvent as apiFetchEvent,
  fetchUserEvents as apiFetchUserEvents,
  hideEvent as apiHideEvent,
  publishEvent as apiPublishEvent,
  unhideEvent as apiUnhideEvent,
} from 'api/userDashboard';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Dispatch, GetState } from '../..';
import { setError } from '../error';
import { pushFlashMessage } from '../flashMessages';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { clearResults } from '../mainSearch';

// Types

export type IdealistDayEvent = ApiIdealistDayEvent & {
  isFetching: boolean;
};
export type State = {
  byId: Record<
    string,
    IdealistDayEvent & {
      isFetching: boolean;
    }
  >;
  list: {
    idealistDayEventIds?: Array<string>;
    isFetching: boolean;
  };
};

type FetchEventRequestAction = {
  type: 'USER_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_REQUEST';
  eventId: string;
};
type FetchEventSuccessAction = {
  type: 'USER_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_SUCCESS';
  event: ApiIdealistDayEvent;
};
type FetchUserEventsRequestAction = {
  type: 'USER_DASHBOARD_FETCH_IDEALIST_DAY_EVENTS_REQUEST';
};
type FetchUserEventsSuccessAction = {
  type: 'USER_DASHBOARD_FETCH_IDEALIST_DAY_EVENTS_SUCCESS';
  events: Array<ApiIdealistDayEvent>;
};
type ClearUserEventsAction = {
  type: 'USER_DASHBOARD_CLEAR_IDEALIST_DAY_EVENTS';
};
type RemoveUserEventAction = {
  type: 'USER_DASHBOARD_REMOVE_IDEALIST_DAY_EVENT';
  eventId: string;
};
export type Action =
  | FetchEventRequestAction
  | FetchEventSuccessAction
  | FetchUserEventsRequestAction
  | FetchUserEventsSuccessAction
  | ClearUserEventsAction
  | RemoveUserEventAction;

// Reducer

export default function idealistDayEventsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    byId: {},
    list: {
      isFetching: false,
    },
  },
  action: Action
) {
  switch (action.type) {
    case 'USER_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.eventId]: {
            ...state.byId[action.eventId],
            id: action.eventId,
            isFetching: true,
          },
        },
      };

    case 'USER_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_SUCCESS': {
      let idealistDayEventIds = state.list.idealistDayEventIds || [];

      if (!idealistDayEventIds.includes(action.event.id)) {
        idealistDayEventIds = [...idealistDayEventIds, action.event.id];
      }

      return {
        ...state,
        byId: {
          ...state.byId,
          [action.event.id]: { ...action.event, isFetching: false },
        },
      };
    }

    case 'USER_DASHBOARD_FETCH_IDEALIST_DAY_EVENTS_REQUEST':
      return { ...state, list: { ...state.list, isFetching: true } };

    case 'USER_DASHBOARD_FETCH_IDEALIST_DAY_EVENTS_SUCCESS': {
      const newState = { ...state };
      action.events.forEach((event) => {
        newState.byId[event.id] = { ...event, isFetching: false };
      });
      newState.list = {
        idealistDayEventIds: action.events.map<string>((e) => e.id),
        isFetching: false,
      };
      return newState;
    }

    case 'USER_DASHBOARD_CLEAR_IDEALIST_DAY_EVENTS':
      return {
        ...state,
        list: {
          isFetching: false,
        },
      };

    case 'USER_DASHBOARD_REMOVE_IDEALIST_DAY_EVENT': {
      const { eventId } = action;
      const eventIds = state.list.idealistDayEventIds || [];
      const idealistDayEventIds: Array<string> = eventIds.filter(
        (id) => id !== eventId
      );
      return { ...state, list: { ...state.list, idealistDayEventIds } };
    }

    default:
      // this causes a flow error if there are any unhandled actions
      action as never;

      return state;
  }
}

// Actions

const fetchUserEventsRequest = (): FetchUserEventsRequestAction => ({
  type: 'USER_DASHBOARD_FETCH_IDEALIST_DAY_EVENTS_REQUEST',
});

const fetchUserEventsSuccess = (
  events: Array<ApiIdealistDayEvent>
): FetchUserEventsSuccessAction => ({
  type: 'USER_DASHBOARD_FETCH_IDEALIST_DAY_EVENTS_SUCCESS',
  events,
});

export const fetchUserEvents =
  () => (dispatch: Dispatch, getState: GetState) => {
    const eventList = getState().userDashboard.idealistDayEvents.list;

    if (!eventList.idealistDayEventIds && !eventList.isFetching) {
      dispatch(fetchUserEventsRequest());
      apiFetchUserEvents()
        .then((fetchedEvents) => {
          dispatch(fetchUserEventsSuccess(fetchedEvents));
        })
        .catch(setError);
    }
  };
export const clearUserEvents = (): ClearUserEventsAction => ({
  type: 'USER_DASHBOARD_CLEAR_IDEALIST_DAY_EVENTS',
});

const fetchEventRequest = (eventId: string): FetchEventRequestAction => ({
  type: 'USER_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_REQUEST',
  eventId,
});

const fetchEventSuccess = (
  event: ApiIdealistDayEvent
): FetchEventSuccessAction => ({
  type: 'USER_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_SUCCESS',
  event,
});

export const fetchEvent =
  (eventId: string) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const event = state.userDashboard.idealistDayEvents.byId[eventId];

    if (!event) {
      dispatch(fetchEventRequest(eventId));
      apiFetchEvent(eventId)
        .then((fetchedEvent) => {
          dispatch(fetchEventSuccess(fetchedEvent));
        })
        .catch((error) => {
          dispatch(setError(error));
        });
    }
  };
export const updateEvent = fetchEventSuccess;
export const addEvent = (event: ApiIdealistDayEvent) => (dispatch: Dispatch) =>
  Promise.all([
    dispatch(updateEvent(event)), // if the list of user events has already been fetched, clear it so it will
    // be reloaded next time the user views it
    dispatch(clearUserEvents()),
  ]);
export const hideEvent = (eventId: string) => (dispatch: Dispatch) =>
  apiHideEvent(eventId)
    .then((event) => {
      dispatch(updateEvent(event));
      dispatch(clearResults());
      dispatch(
        pushFlashMessage({
          type: 'LISTING_HIDDEN',
        })
      );
    })
    .catch(setError);
export const unhideEvent = (eventId: string) => (dispatch: Dispatch) =>
  apiUnhideEvent(eventId)
    .then((event) => {
      dispatch(updateEvent(event));
      dispatch(clearResults());
      dispatch(
        pushFlashMessage({
          type: 'LISTING_UNHIDDEN',
        })
      );
    })
    .catch(setError);
export const publishEvent = (eventId: string) => (dispatch: Dispatch) =>
  apiPublishEvent(eventId)
    .then((event) => {
      dispatch(updateEvent(event));
      dispatch(clearResults());
      dispatch(
        pushFlashMessage({
          type: 'EVENT_PENDING_APPROVAL',
        })
      );
    })
    .catch(setError);

const removeUserEvent = (eventId: string): RemoveUserEventAction => ({
  type: 'USER_DASHBOARD_REMOVE_IDEALIST_DAY_EVENT',
  eventId,
});

export const deleteEvent = (eventId: string) => (dispatch: Dispatch) =>
  apiDeleteEvent(eventId)
    .then((deletedEvent) => {
      dispatch(updateEvent(deletedEvent));
      dispatch(removeUserEvent(eventId));
      dispatch(clearResults());
    })
    .catch(setError);
